import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
  registerGamepadEvents,
  registerKeyboardEvents,
  registerMouseEvents,
  sendClickEvent,
  sendColor,
  sendThickness,
  sendText,
  sendJson,
  sendJsonArray,
} from '../utils/register-events';

import { RenderStreaming } from "../webrtc/renderstreaming";
// import { VideoPlayer } from '../utils/videoplayer';
import { ConfigServerService, getRTCConfiguration, getServerConfig } from '../configs/config';
import { ButtonsEnum } from '../models/buttons-enum';
import { WebSocketSignalingService } from '../signaling/websocket-signaling.service';
import { SignalingService } from '../signaling/signaling.service';
import { createDisplayStringArray } from '../utils/stats';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { VideoplayerComponent } from '../videoplayer/videoplayer.component';
import { Logger } from '../utils/logger';
import { DjangoChannelEventData, DjangoChannelService } from '../utils/django-channel.service';
import { Subscription } from 'rxjs';
// import { environment } from '../../environments/environment';
import { AudioTranslatorService, TranslationMode, TranslationResult } from '../services/audio-translator.service';
import { FormsModule } from '@angular/forms';
import { ButtonIconComponent } from './components/button-icon/button-icon.component';
import { Peer } from '../webrtc/peer';
import { VideoService } from '../services/video.service';
import { BlurVideoFilterService, FaceDetectionOptions } from '../services/blur-video-filter.service';
import { RecorderService } from '../services/recorder.service';
import { EnvironmentService } from '../configs/environment.service';
import { ExplorerService } from 'filemanager-explorer';
import { CallDiagnostics, callCounters, readCallDiagnostics } from '../utils/call-diagnostics';

declare const window: any;

declare const createUnityInstance: (canvas: any, config: any) => any;

const MaxTextLength = 256;
// Translated phrases kept in the subtitles chat during a call
const MAX_SUBTITLES = 50;
// After the headset's first offer, the panel adds drawing channel and microphone line in one renegotiation
const CHANNEL_SETUP_DELAY_MS = 5000;
// Pause before reopening a websocket that closed by itself: doubles at every failure, up to the maximum
const RECONNECT_BASE_MS = 500;
const RECONNECT_MAX_MS = 10_000;
const DIAGNOSTICS_STORAGE_KEY = 'xrsupport.callDiagnostics';
const VIDEO_CODEC_STORAGE_KEY = 'xrsupport.videoCodec';

@Component({
    selector: 'app-web-rtc-communication',
    imports: [
        NgIf,
        NgFor,
        NgClass,
        VideoplayerComponent,
        FormsModule,
        ButtonIconComponent,
        TranslateModule
    ],
    templateUrl: './web-rtc-communication.component.html',
    // styleUrl: './web-rtc-communication.component.scss',
    styleUrls: ['./web-rtc-communication.component.scss', './additional_style.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
export class WebRtcCommunicationComponent implements OnInit, AfterViewInit {
  

  playButtonVisible: boolean = false;
  showWarning = false;
  warningText = "";
  showMessage = false;
  messageText = "";
  openChat: boolean = false;
  openTranslate: boolean = false;
  openDraw: boolean = false;

  // @ViewChild('playButton') playButton!: HTMLElement;
  // @ViewChild('warning') warning!: HTMLElement;
  // @ViewChild('codecPreferences') codecPreferences!: HTMLSelectElement;

  // codecPreferencesShow = environment.codecPreferencesShow || false;
  codecPreferencesShow = false;
  codecPreferencesDisabled = true;
  codecPreferencesOptions: any[] = [];
  codecPreferencesSelectedValue: any = null;

  @ViewChild('unityCanvas') unityCanvas!: ElementRef;

  @ViewChild('player') player!: any;
  // @ViewChild('Video', { static: false }) elementVideo!: HTMLElement;
  @ViewChild('videoplayer') videoPlayer!: VideoplayerComponent;

  @ViewChild('colorPicker') color!: ElementRef;
  @ViewChild('thickness') thickness!: ElementRef;

  @ViewChild("textInput", { static: false }) textInput!: any;
  // @ViewChild("message", { static: false }) messageDiv!: HTMLDivElement;

  renderstreaming!: RenderStreaming | null;
  useWebSocket: boolean = false;
  showControls: boolean = false;

  lockMouseCheck: ElementRef | null = document.getElementById("lockMouseCheck") as ElementRef | null;
  // lockMouseCheckShow = environment.lockMouseCheckShow || false;
  lockMouseCheckShow = false;
  // videoPlayer: VideoPlayer = new VideoPlayer();

  disableUnityVoice: boolean = false;

  isTranslateEnabled: boolean = false;
  isTranslateVisible: boolean = false;

  // unityCanasInit = false;

  showUnityCanvas = true;

  @Input() connectionId!: string;
  @Input() backendUrl?: string;

  tenantId: string = "";

  /** @type {RTCStatsReport} */
  lastStats?: RTCStatsReport;
  /** @type {number} */
  intervalId!: any; // number | Timeout

  supportsSetCodecPreferences =
    window.RTCRtpTransceiver &&
    "setCodecPreferences" in window.RTCRtpTransceiver.prototype;

  ButtonsEnum = ButtonsEnum;
  isStatsEnabled!: boolean;
  micon: boolean = false;
  buttonsActive = {
    freehands: true,
    rectangle: false,
    circle: false,
    arrow: false
  }

  localStream!: MediaStream;
  isSetupWebgl: boolean = false;
  showVideoControls: boolean = false;
  djangoSubscription: Subscription | null = null;
  addedStreamTransceiver: RTCRtpTransceiver[] | null | undefined;
  private _signaling?: WebSocketSignalingService | SignalingService;
  isMakingSetup: boolean = false;
  channel: RTCDataChannel | null | undefined;
  isDataChannelReady: boolean = false;
  dataChannelCheckTimer: any;

  sourceLanguage: string = "it-IT";
  targetLanguage: string = "en-GB";
  isLocalTranslating: boolean = false;
  isRemoteTranslating: boolean = false;
  remoteStream: MediaStream | null = null;
  languages: { value: string; label: string; }[];
  // Translated phrases of this call, shown as a chat in the bottom-right corner
  subtitles: (TranslationResult & { id: number })[] = [];
  subtitlesCollapsed: boolean = false;
  @ViewChild('subtitlesList') subtitlesList?: ElementRef<HTMLDivElement>;
  private subtitleId = 0;
  translationSubscription: Subscription | null = null;
  // A second click while a translation is starting would start a second recorder (every phrase sent twice)
  private translationStarting = { local: false, remote: false };
  // Remote translation that was on when the headset dropped: it restarts on the new remote audio
  private resumeRemoteTranslation = false;

  // Every connection attempt has its own number: callbacks of an older one are ignored
  private connectionSeq = 0;
  private destroyed = false;
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null;
  private reconnectAttempts = 0;
  private channelSetupTimer: ReturnType<typeof setTimeout> | null = null;
  // Audio line for the microphone, negotiated together with the drawing channel: switching the mic on needs no new offer
  private micTransceiver: RTCRtpTransceiver | null = null;

  // Diagnostics panel (Ctrl+Alt+D): what the panel measures of the call
  showDiagnostics = false;
  diagnostics: CallDiagnostics | null = null;
  readonly counters = callCounters;
  private diagnosticsTimer: ReturnType<typeof setInterval> | null = null;
  private lastDiagnosticsStats?: RTCStatsReport;

  isRecording: boolean = false;
  recordingTime: string = '00:00';
  private recordingTimer: any;
  isRecordingVisible: boolean = false;
  canBlur: boolean = true;
  mustBlur: boolean = true;
  isBlur: boolean = false;
  recognitionModel: string = 'ssd';
  recognitionModelUrl: string = '/assets/models';
  recognitionOptions!: FaceDetectionOptions;

  constructor(
    // private videoPlayer: VideoPlayer,
    private configServer: ConfigServerService,
    private djangoChannelService: DjangoChannelService,
    private videoService: VideoService,
    private audioTranslatorService: AudioTranslatorService,
    private recorderService: RecorderService,
    private blurVideoFilterService: BlurVideoFilterService,
    private environmentService: EnvironmentService,
    private explorerService: ExplorerService
  ) {
    this.setupWindowEvents();

    this.languages = this.audioTranslatorService.getLanguages();
    if (window.environment) {
      for (const key in window.environment) {
        if (window.environment.hasOwnProperty(key)) {
          // environment[key] = window.environment[key];
          environmentService.set(key, window.environment[key]);
        }
      }
    }

    // this.isTranslateEnabled = environment.isTranslateEnabled ?? true;
    this.isTranslateEnabled = environmentService.get("isTranslateEnabled") ?? true;
    // this.isTranslateVisible = environment.isTranslateVisible ?? true;
    this.isTranslateVisible = environmentService.get("isTranslateVisible") ?? true;

    // this.isRecordingVisible = environment.isRecordingVisible ?? true;
    this.isRecordingVisible = environmentService.get("isRecordingVisible") ?? true;

    // this.isStatsEnabled = environment.isStatsEnabled || false;
    this.isStatsEnabled = environmentService.get("isStatsEnabled") || false;
    // this.lockMouseCheckShow = environment.lockMouseCheckShow || false;
    this.lockMouseCheckShow = environmentService.get("lockMouseCheckShow") || false;
    // this.codecPreferencesShow = environment.codecPreferencesShow || false;
    this.codecPreferencesShow = environmentService.get("codecPreferencesShow") || false;
    // this.disableUnityVoice = environment.disableUnityVoice || false;
    this.disableUnityVoice = environmentService.get("disableUnityVoice") || false;
    // this.showVideoControls = environment.showVideoControls || false;
    this.showVideoControls = environmentService.get("showVideoControls") || false;

    this.recognitionModel= environmentService.get("recognitionModel") || 'ssd';
    this.recognitionModelUrl = environmentService.get("recognitionModelUrl") || '/assets/models';
    if(environmentService.get("recognitionOptions")) {
      this.recognitionOptions = environmentService.get("recognitionOptions");
    }

    this.audioTranslatorService.onSourceLanguageChange(this.sourceLanguage);
    this.audioTranslatorService.onTargetLanguageChange(this.targetLanguage);
  }


  setupWindowEvents() {
    window.document.oncontextmenu = function () {
      return false; // cancel default menu
    };

    window.addEventListener(
      "resize",
      () => {
        this.videoPlayer.resizeVideo();
      },
      true
    );

    window.addEventListener(
      "beforeunload",
      async () => {
        if (!this.renderstreaming) return;
        await this.renderstreaming.stop();
      },
      true
    );
  }

  // const codecPreferences = document.getElementById("codecPreferences");



  // const messageDiv = document.getElementById("message");
  // messageDiv.style.display = "none";



  // const playerDiv = document.getElementById("player");

  async ngOnInit() {
    // if (this.messageDiv) {
    //   this.messageDiv.style.display = "none";
    // }
    this.showMessage = false;
    await this.setup();

    if(this.mustBlur || this.canBlur) {
      console.log("loading blur video filter");
      await this.loadBlurVideoFilterLibrary();
      await this.loadBlurVideoFilterModel();
    }

    this.djangoSubscription = this.djangoChannelService.getObservable().subscribe((event: DjangoChannelEventData) => {
      if (event.event === 'djangoChannel' && event.data &&
        (event.data.event === 'sendDocuments') ) {
          let urls: any = null;
          if(event.data.urls) {
            urls = event.data.urls
          }
          if(event.data.data.urls){
            urls = event.data.data.urls
          }

        // TODO invocare la funzione di alessandro per impacchettare gli url...
        if (urls &&Array.isArray(urls)) {
          const isSent = sendJsonArray(this.videoPlayer, urls);
          console.log('djangoChannel sendDocuments', isSent)
        }
      }
    })

    this.translationSubscription = this.audioTranslatorService.translations$.subscribe((result: TranslationResult) => {
      this.showSubtitle(result);
    });

    this.tenantId = this.extractTenantFromConnectionId(this.connectionId);

    // this.setupWebGL();

    // setInterval(() => {
    //   this.isDataChannelReady = !this.isDataChannelReady
    // }, 2000);

    this.videoService.setPlayer(this.videoPlayer);
    this.videoService.addManager(this.recorderService, {});

    if (this.readStorage(DIAGNOSTICS_STORAGE_KEY) === '1') {
      this.toggleDiagnostics();
    }
  }

  extractTenantFromConnectionId(connectionId: string): string {
    // TODO: effettuare il parsing del connectionId per ottenere il tenantId
    return connectionId;
  }

  ngOnDestroy(): void {
    // Nothing may reconnect after the page is left (a socket reopened here kept answering offers)
    this.destroyed = true;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    this.stopDiagnostics();
    void this.teardownConnection();

    try {
      if (this.djangoSubscription) {
        this.djangoSubscription.unsubscribe();
      }
    } catch (error) {
      console.log('error ' + error);
    }

    this.translationSubscription?.unsubscribe();

    // End of the call: translations off, microphone and audio contexts released
    this.isLocalTranslating = false;
    this.isRemoteTranslating = false;
    this.resumeRemoteTranslation = false;
    this.audioTranslatorService.dispose();
    this.localStream?.getTracks().forEach((track: MediaStreamTrack) => track.stop());

    // Rimozione di tutti i filtri in modo da disabilitare i resize;
    // TODO: distruggere tutti i services
    if(this.videoService) {
      this.videoService.removeAllFilters();
    }

    window.document.oncontextmenu = function () {
      return true; // cancel default menu
    };

  }

  ngAfterViewInit() {
    this.videoPlayer.resizeVideo();
    // this.setupWebGL();
  }

  setupWebGL() {
    // createUnityInstance(document.querySelector("#unity-canvas"), {
    //   dataUrl: "http://localhost/xrsupport/Build/WebGL.data",
    //   frameworkUrl: "http://localhost/xrsupport/Build/WebGL.framework.js",
    //   codeUrl: "http://localhost/xrsupport/Build/WebGL.wasm",
    //   streamingAssetsUrl: "StreamingAssets",
    //   companyName: "digitalmens",
    //   productName: "XR Support",
    //   productVersion: "0.2.273r",
    //   // matchWebGLToCanvasSize: false, // Uncomment this to separately control WebGL canvas render size and DOM element size.
    //   // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
    // });
    if (this.disableUnityVoice || this.isSetupWebgl)
      return;
    this.isSetupWebgl = true;

    // createUnityInstance(document.querySelector("#unity-canvas"), {
    //   dataUrl: environment.beHost + "/xrsupport/Build/WebGL.data",
    //   frameworkUrl: environment.beHost + "/xrsupport/Build/WebGL.framework.js",
    //   codeUrl: environment.beHost + "/xrsupport/Build/WebGL.wasm",
    //   streamingAssetsUrl: "StreamingAssets",
    //   companyName: "digitalmens",
    //   productName: "XR Support",
    //   productVersion: "0.2.273r",
    //   // matchWebGLToCanvasSize: false, // Uncomment this to separately control WebGL canvas render size and DOM element size.
    //   // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
    // });
  }

  setupPlayerEvents(vp: VideoplayerComponent, vpElement: HTMLElement) {
    // const videoPlayer = new VideoPlayer(elements);
    // await videoPlayer.setupConnection(useWebSocket);

    this.videoPlayer.ondisconnect = this.onDisconnect;
    registerGamepadEvents(vp);
    registerKeyboardEvents(vp);
    registerMouseEvents(vp, vpElement);

    // return videoPlayer;
  }

  startAudio() {
    console.log("start audio");

    const buttonArea = {
      x: 0,
      y: 0,
      width: 160,
      height: 48
    };

    if (this.unityCanvas) {
      const canvas = this.unityCanvas.nativeElement;
      console.log(canvas);
      canvas.focus();
      canvas.click();

      // const simulatedEvent = new MouseEvent('click', {
      //   clientX: buttonArea.x + buttonArea.width / 2,
      //   clientY: buttonArea.y + buttonArea.height / 2,
      //   view: window,
      //   bubbles: true,
      //   cancelable: true
      // });

      // // Invia l'evento di click simulato al canvas
      // canvas.dispatchEvent(simulatedEvent);

      // const simulatedEvent2 = new MouseEvent('mousedown', {
      //   clientX: buttonArea.x + buttonArea.width / 2,
      //   clientY: buttonArea.y + buttonArea.height / 2,
      //   view: window,
      //   bubbles: true,
      //   cancelable: true
      // });

      // // Invia l'evento di click simulato al canvas
      // canvas.dispatchEvent(simulatedEvent2);

      // const rect = canvas.getBoundingClientRect();
      // const x = rect.left + buttonArea.width / 2;
      // const y = rect.top + buttonArea.height / 2;

      // const simulatedEvent1 = new MouseEvent('click', {
      //   clientX: rect.left + buttonArea.width / 2,
      //   clientY: rect.top + buttonArea.height / 2,
      //   view: window,
      //   bubbles: true,
      //   cancelable: true
      // });

      // document.body.dispatchEvent(simulatedEvent1);

      // const simulatedEvent3 = new MouseEvent('mousedown', {
      //   clientX: rect.left + buttonArea.width / 2,
      //   clientY: rect.top + buttonArea.height / 2,
      //   view: window,
      //   bubbles: true,
      //   cancelable: true
      // });

      // document.body.dispatchEvent(simulatedEvent3);

      const rect = canvas.getBoundingClientRect();
      const simulatedX = rect.left + buttonArea.width / 2;
      const simulatedY = rect.top + buttonArea.height / 2;

      // Simula il click all'interno del canvas, usando le coordinate corrette
      const simulatedClick = new MouseEvent('click', {
        clientX: simulatedX,
        clientY: simulatedY,
        view: window,
        bubbles: true,
        cancelable: true
      });

      canvas.dispatchEvent(simulatedClick);

      // Prova anche con pointerdown e pointerup, poiché Unity potrebbe aspettarsi questi eventi
      const simulatedPointerDown = new PointerEvent('pointerdown', {
        clientX: simulatedX,
        clientY: simulatedY,
        view: window,
        bubbles: true,
        cancelable: true
      });

      const simulatedPointerUp = new PointerEvent('pointerup', {
        clientX: simulatedX,
        clientY: simulatedY,
        view: window,
        bubbles: true,
        cancelable: true
      });

      canvas.dispatchEvent(simulatedPointerDown);
      canvas.dispatchEvent(simulatedPointerUp);

      const simulatedMouseDown = new MouseEvent('mousedown', {
        clientX: simulatedX,
        clientY: simulatedY,
      });
      canvas.focus();
      canvas.dispatchEvent(simulatedMouseDown);

      const simulatedMouseDown1 = new MouseEvent('down', {
        clientX: simulatedX,
        clientY: simulatedY,
      });
      canvas.focus();
      canvas.dispatchEvent(simulatedMouseDown1);

    }
  }



  async setup() {
    if(!this.backendUrl) {
      // if(environment.beHost) {
      //   this.backendUrl = environment.beHost
      // } else {
      //   this.backendUrl = location.origin
      // }
      if(this.environmentService.get('beHost')) {
        this.backendUrl = this.environmentService.get('beHost')
      } else {
        this.backendUrl = location.origin
      }
    }
    if(this.backendUrl){
      this.audioTranslatorService.setBackendUrl(this.backendUrl);
    }
    const apiBaseUrl = this.environmentService.get('api')?.base_url;
    if (apiBaseUrl) {
      this.audioTranslatorService.setSpeechApiUrl(`${apiBaseUrl}/rag/speech/transcribe`);
    }
    // Off where the signaling server has no working /backoffice/speech-log (test)
    this.audioTranslatorService.setSpeechLogEnabled(this.environmentService.get('isSpeechLogEnabled') !== false);
    // this.configServer.getServerConfig(this.backendUrl, this.connectionId).then((res: any) => {
    //   this.useWebSocket = res.useWebSocket;
    //   // this.showWarningIfNeeded(res.startupMode);
    //   this.showCodecSelect();
    //   this.showPlayButton();
    //   // this.isTranslateEnabled = res.canTranslate ?? environment.isTranslateEnabled;
    //   this.isTranslateEnabled = res.canTranslate ?? this.environmentService.get("isTranslateEnabled");
    //   // this.isTranslateVisible = res.isTransalteEnabled ?? environment.isTranslateEnabled;
    //   this.isTranslateVisible = res.isTransalteEnabled ?? this.environmentService.get("isTranslateEnabled");

    //   this.canBlur = res.canBlur ?? this.environmentService.get("canBlur") ?? true
    //   this.mustBlur = res.mustBlur ?? this.environmentService.get("mustBlur") ?? false
    // })

    const res: any = await this.configServer.getServerConfig(this.backendUrl, this.connectionId)
    
    this.useWebSocket = res.useWebSocket;
    // this.showWarningIfNeeded(res.startupMode);
    this.showCodecSelect();
    this.showPlayButton();
    // this.isTranslateEnabled = res.canTranslate ?? environment.isTranslateEnabled;
    this.isTranslateEnabled = res.canTranslate ?? this.environmentService.get("isTranslateEnabled");
    // this.isTranslateVisible = res.isTransalteEnabled ?? environment.isTranslateEnabled;
    this.isTranslateVisible = res.isTransalteEnabled ?? this.environmentService.get("isTranslateEnabled");

    this.canBlur = res.canBlur ?? this.environmentService.get("canBlur") ?? true
    this.mustBlur = res.mustBlur ?? this.environmentService.get("mustBlur") ?? true
    


  }

  showWarningIfNeeded(startupMode: string) {
    // const warningDiv = document.getElementById("warning");
    // if (startupMode == "private") {
    //   warningDiv.innerHTML =
    //     "<h4>Warning</h4> This sample is not working on Private Mode.";
    //   warningDiv.hidden = false;
    // }
    // this.warning.innerHTML = `Warning: This sample is not working on ${startupMode} Mode.`;
    this.showWarning = true;
    this.warningText = "Warning: This sample is not working on " + startupMode + " Mode.";
  }

  showPlayButton() {
    this.playButtonVisible = true;
  }

  toggleChat() {
    if(!this.isDataChannelReady) {
      return;
    }
    this.openChat = !this.openChat;
    this.openTranslate = false;
    this.openDraw = false;
  }

  toggleTranslate() {
    this.openTranslate = !this.openTranslate;
    this.openChat = false;
    this.openDraw = false;
  }

  toggleDraw() {
    if(!this.isDataChannelReady) {
      return;
    }
    this.openDraw = !this.openDraw;
    this.openTranslate = false;
    this.openChat = false;
  }



  onClickPlayButton() {
    // if (!this.unityCanasInit) {
    //   this.unityCanasInit = true;

    //   // var unityCanvas = document.getElementById("unity-canvas");
    //   // if (unityCanvas != null) unityCanvas.style.display = "block";
    //   if (this.unityCanvas) {
    //     this.unityCanvas.style.display = "block";
    //   }
    // }
    this.explorerService.currentView$.next('List')
      
    if(this.mustBlur) {
      this.startBlur();
    }

    this.showUnityCanvas = true;

    // this.playButton.style.display = "none";
    this.playButtonVisible = false;

    // add video player
    this.videoPlayer.createPlayer(this.player.nativeElement, this.lockMouseCheck?.nativeElement);
    this.videoService.setup(this.videoPlayer);
    this.videoService.setVideoMediaSource();

    // alexandros
    console.log("before setupPlayerEvents");
    const ve = this.videoPlayer.getVideoElement();
    if (ve) {
      this.setupPlayerEvents(this.videoPlayer, ve);
    }
    console.log("after setupPlayerEvents");

    this.setupRenderStreaming();

    this.controlsSetup();
    setTimeout(() => {
      console.log('setup web gl')
      this.setupWebGL();
      console.log('setup web gl started')
    }, 500);

    // if(this.localStream) {
    //   this._attachLocalStream(this.localStream);
    // }

  }

  takeScreenshot() {
    if(!this.isDataChannelReady)
      return;
    const dataUrl = this.videoPlayer.takeScreenshot();
    if(dataUrl) {
      // TODO: salvare l'immagine in locale e sul server tramite api
      // if(environment.saveScreenshotOnServer){
      //   this.saveScreenshotOnServer(dataUrl);
      // }
      if(this.environmentService.get('saveScreenshotOnServer')) {
        const now = (new Date()).getTime();
        const filename = 'screenshot_' + now + '_' + this.connectionId
        this.saveScreenshotOnServer(dataUrl, filename);
      }
      // console.log(dataUrl);
      // if(environment.saveLocallyScreenshot) {
      //   this.saveLocallyScreenshot(dataUrl);
      // }
      if(this.environmentService.get('saveLocallyScreenshot')) {
        this.saveLocallyScreenshot(dataUrl);
      }
    }
  }

  saveLocallyScreenshot(dataUrl: string) {
    const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'screenshot.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  }

  saveScreenshotOnServer(dataUrl: string, filename: string) {
    this.djangoChannelService.sendData({
      event: 'saveScreenshot',
      data: {
        dataUrl: dataUrl,
        filename: filename
      }
    });
  }

  buttonClicked(action: number) {
    if(!this.isDataChannelReady) {
      return;
    }
    sendClickEvent(this.videoPlayer, action);
    this.changeButtonActive(action);
  }

  changeButtonActive(action: number) {
    this.buttonsActive.arrow = ButtonsEnum.Arrow == action;
    this.buttonsActive.circle = ButtonsEnum.Circle == action;
    this.buttonsActive.freehands = ButtonsEnum.FreeHand == action;
    this.buttonsActive.rectangle = ButtonsEnum.Rectangle == action;
  }

  resetButtonActive() {
    this.buttonsActive.arrow = false;
    this.buttonsActive.circle = false;
    this.buttonsActive.freehands = true;
    this.buttonsActive.rectangle = false;
  }


  onColorChange() {
    if(!this.isDataChannelReady) {
      return;
    }
    sendColor(this.videoPlayer, this.color.nativeElement.value);
  }

  onThicknessChange() {
    if(!this.isDataChannelReady) {
      return;
    }
    sendThickness(this.videoPlayer, this.thickness.nativeElement.value);
  }

  charCount: string = "0/" + MaxTextLength;

  controlsSetup() {
    this.showControls = true;
  }

  sendTextMessage() {
    const content = this.textInput.nativeElement.value;

    sendText(this.videoPlayer, content, MaxTextLength * 2);
    // alert("Contenuto inviato: " + content);

    this.textInput.nativeElement.value = "";
    this.handleTextAreaInput();
  }



  handleTextAreaInput() {

    const text = this.textInput.nativeElement.value;
    const textLength = text.length;

    // console.log(text + " - " + textLength);

    if (textLength > MaxTextLength) {
      this.textInput.nativeElement.value = text.slice(0, MaxTextLength);
    }

    this.charCount = this.textInput.nativeElement.value.length + "/" + MaxTextLength;
  }

  toggleLocalTranslation() {
    // this.isLocalTranslating = !this.isLocalTranslating;
    // The button stays clickable while the mic is off only to show why it can't start
    if(!this.micon && !this.isLocalTranslating) {
      return;
    }
    if(this.localStream && !this.translationStarting.local) {
      if(this.isLocalTranslating) {
        this.audioTranslatorService.onLocalTranslationModeChange(TranslationMode.DISABLED);
        this.isLocalTranslating = false;
      } else {
        this.translationStarting.local = true;
        this.audioTranslatorService.onLocalTranslationModeChange(TranslationMode.ENABLED, this.localStream).then(() => {
        this.isLocalTranslating = true;
        }).catch((error) => {
          console.log('error', error);
          // alert...
          alert('Non è stato possibile abilitare la traduzione');
        }).finally(() => {
          this.translationStarting.local = false;
        });
      }
    }
  }

  toggleRemoteTranslation() {
    // this.isRemoteTranslating = !this.isRemoteTranslating;
    if(this.remoteStream && !this.translationStarting.remote) {
      if(this.isRemoteTranslating) {
        this.audioTranslatorService.onRemoteTranslationModeChange(TranslationMode.DISABLED);
        this.isRemoteTranslating = false;
      } else {
        this.translationStarting.remote = true;
        this.audioTranslatorService.onRemoteTranslationModeChange(TranslationMode.ENABLED, this.remoteStream).then(() => {
          this.isRemoteTranslating = true;
        }).catch((error) => {
          console.log('error', error);
          // alert...
          alert('Non è stato possibile abilitare la traduzione');
        }).finally(() => {
          this.translationStarting.remote = false;
        });
      }
    }
  }

  showSubtitle(result: TranslationResult) {
    const subtitle = { ...result, id: ++this.subtitleId };
    this.subtitles = [...this.subtitles, subtitle].slice(-MAX_SUBTITLES);
    // Keep the newest phrase in view once Angular has rendered it
    setTimeout(() => {
      const list = this.subtitlesList?.nativeElement;
      if (list) {
        list.scrollTop = list.scrollHeight;
      }
    });
  }

  toggleSubtitles() {
    this.subtitlesCollapsed = !this.subtitlesCollapsed;
    if (!this.subtitlesCollapsed) {
      setTimeout(() => {
        const list = this.subtitlesList?.nativeElement;
        if (list) {
          list.scrollTop = list.scrollHeight;
        }
      });
    }
  }

  handleSourceLanguageChange() {
    this.audioTranslatorService.onSourceLanguageChange(this.sourceLanguage);
  }

  handleTargetLanguageChange() {
    this.audioTranslatorService.onTargetLanguageChange(this.targetLanguage);
  }


  async setupRenderStreaming() {

    if(this.isMakingSetup || this.destroyed) {
      return;
    }
    console.log('WEBCOMPONENT - setupRenderStreaming');
    this.isMakingSetup = true;
    const seq = ++this.connectionSeq;
    const isCurrent = () => seq === this.connectionSeq && !this.destroyed;
    // this.codecPreferences.disabled = true;
    this.codecPreferencesDisabled = true;

    const signaling = this.useWebSocket ? new WebSocketSignalingService(this.environmentService) : new SignalingService();
    this._signaling = signaling;
    if(signaling instanceof WebSocketSignalingService) {
      signaling.connectionId = this.connectionId;
      signaling.addEventListener('wsclose', () => {
        if (isCurrent()) {
          this.scheduleReconnect('websocket della segnalazione chiuso');
        }
      });
    }
    // let config: RTCConfiguration | string = window.rtcConfig || environment.rtcConfig || getRTCConfiguration();
    let config: RTCConfiguration | string = window.rtcConfig || this.environmentService.get('rtcConfig') || getRTCConfiguration();
    if(typeof config === 'object') {
     config = Peer.convertRTCConfigurationToString(config);
    }
    // const config: RTCConfiguration = getRTCConfiguration();
    const renderstreaming = new RenderStreaming(signaling, config);
    this.renderstreaming = renderstreaming;
    renderstreaming.onConnect = () => isCurrent() && this.onConnect();
    renderstreaming.onDisconnect = (connectionId) => isCurrent() && this.onDisconnect(connectionId);
    // this.renderstreaming.onTrackEvent = (data) => this.videoPlayer.addTrack(data.track);
    renderstreaming.onTrackEvent = (data) => isCurrent() && this.onAddTrack(data);
    // Runs between the headset's offer and our answer: the answer carries the codec order
    renderstreaming.onGotOffer = () => isCurrent() && this.setCodecPreferences();
    renderstreaming.onFirstNegotiationEnd = () => {
      console.log('WEBCOMPONENT - onFirstNegotiationEnd');
      if (isCurrent()) {
        this._setupChannelAndStream();
      }
    }
    renderstreaming.onOfferUnanswered = () => {
      // Video and headset audio keep flowing; drawing channel and microphone wait for the headset's next offer
      console.warn('[connessione] il visore non ha risposto: disegno e microfono attivi alla sua prossima proposta');
    };

    await renderstreaming.start();
    if (!isCurrent()) {
      return;
    }
    await renderstreaming.createConnection(this.connectionId, 'web');
    this.reconnectAttempts = 0;
    this.isMakingSetup = false;
  }

  /**
   * The only way the call reconnects (websocket closed, headset gone, ICE failed): the old connection is
   * closed completely before a new one is opened, so there is never more than one.
   */
  private scheduleReconnect(reason: string, immediate: boolean = false): void {
    if (this.destroyed || this.reconnectTimer) {
      return;
    }
    const delay = immediate ? 0 : Math.min(RECONNECT_BASE_MS * 2 ** this.reconnectAttempts, RECONNECT_MAX_MS);
    this.reconnectAttempts++;
    console.warn(`[connessione] ${reason}: nuovo collegamento tra ${delay} ms`);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      void this.reconnect();
    }, delay);
  }

  private async reconnect(): Promise<void> {
    await this.teardownConnection();
    if (this.destroyed) {
      return;
    }
    callCounters.reconnections++;
    this.videoPlayer.deletePlayer();
    if (this.supportsSetCodecPreferences) {
      // this.codecPreferences.disabled = false;
      this.codecPreferencesDisabled = false;
    }

    this.videoService.removeAllTracks(true)
    this.remoteStream = null;

    this.showPlayButton();

    try {
      this.onClickPlayButton();
    } catch (error) {
      console.log("on disconnect exception " + error);
    }
  }

  /** Closes everything of the current connection: websocket and its listeners, peer, channel and their timers. */
  private async teardownConnection(): Promise<void> {
    this.connectionSeq++;
    this.isMakingSetup = false;
    if (this.channelSetupTimer) {
      clearTimeout(this.channelSetupTimer);
      this.channelSetupTimer = null;
    }
    this.dataChannelCheck(false);
    this.clearStatsMessage();
    this.channel = null;
    this.isDataChannelReady = false;
    this.micTransceiver = null;
    this.addedStreamTransceiver = null;
    this.lastDiagnosticsStats = undefined;
    // The recorder is tied to the remote audio of this connection: it restarts on the next one
    if (this.isRemoteTranslating) {
      this.audioTranslatorService.onRemoteTranslationModeChange(TranslationMode.DISABLED);
      this.isRemoteTranslating = false;
      this.resumeRemoteTranslation = true;
    }
    const renderstreaming = this.renderstreaming;
    this.renderstreaming = null;
    this._signaling = undefined;
    try {
      await renderstreaming?.stop();
    } catch (error) {
      console.log('error ' + error);
    }
  }

  onConnect() {
    Logger.log("onConnect");
    // this._setupChannelAndStream();
  }

  _setupChannelAndStream() {
    // The headset offers only video and audio to send: drawing channel and microphone line need one offer from us,
    // made once for both (the microphone is then switched on with replaceTrack, without another offer)
    if (this.channelSetupTimer) {
      clearTimeout(this.channelSetupTimer);
    }
    this.channelSetupTimer = setTimeout(() => {
      this.channelSetupTimer = null;
      this.channel = this.renderstreaming?.createDataChannel("input");
    if (this.channel) {
      this.videoPlayer.setupInput(this.channel, this.onDataChannelConnected.bind(this));

      if (this.isStatsEnabled) {
        this.showStatsMessage();
      }

      this.channel.onclose = () => {
        this.checkDataChannelStatus();
      }

      this.dataChannelCheck(true);

    }
    this.micTransceiver = this.renderstreaming?.addTransceiver('audio', { direction: 'sendrecv' }) ?? null;
    if(this.localStream) {
      this._attachLocalStream(this.localStream);
    }
    }, CHANNEL_SETUP_DELAY_MS);

  }

  onDataChannelConnected(channel: RTCDataChannel) {
    this.checkDataChannelStatus();
    this.buttonClicked(ButtonsEnum.FreeHand)
  }


  checkDataChannelStatus() {
    if (this.channel && this.channel.readyState === 'open') {
      this.isDataChannelReady = true;
    } else {
      this.isDataChannelReady = false;
    }
  }

  dataChannelCheck(start: boolean = true) {
    if(this.dataChannelCheckTimer) {
      clearInterval(this.dataChannelCheckTimer);
      this.dataChannelCheckTimer = null;
    }
    if(start) {
      this.dataChannelCheckTimer = setInterval(() => {
        this.checkDataChannelStatus();
      }, 1000);
    }
  }



  async onDisconnect(connectionId: string) {
    this.clearStatsMessage();
    // this.messageDiv.style.display = "block";
    // this.messageDiv.innerText = `Disconnect peer on ${connectionId}.`;
    // this.showMessage = environment.showStatsMessage && true;
    this.showMessage = this.environmentService.get('showStatsMessage') && true;
    this.messageText = `Disconnect peer on ${connectionId}.`;

    // Ready at once for the headset to come back, as before
    this.scheduleReconnect(`collegamento chiuso (${connectionId})`, true);
  }

  onCodecPreferencesChange($event: any) {
    this.codecPreferencesSelectedValue = $event.target.value;
  }

  /**
   * Video codec the panel asks the headset to send, first in our answer: H264 is compressed by the headset's
   * hardware, VP8 (its default) in software. The other codecs stay allowed, so a headset without it still connects.
   * localStorage 'xrsupport.videoCodec' overrides the environment ('video/VP8' to compare, 'none' for the default).
   */
  setCodecPreferences() {
    if (!this.supportsSetCodecPreferences) {
      return;
    }
    let preferred: string | null = this.environmentService.get('preferredVideoCodec') || null;
    const override = this.readStorage(VIDEO_CODEC_STORAGE_KEY);
    if (override) {
      preferred = override === 'none' ? null : override;
    }
    if (this.codecPreferencesSelectedValue) {
      preferred = String(this.codecPreferencesSelectedValue).split(' ')[0];
    }
    if (!preferred) {
      return;
    }
    const wanted = preferred.toLowerCase();
    const codecs = (RTCRtpReceiver.getCapabilities?.('video') ?? RTCRtpSender.getCapabilities('video'))?.codecs ?? [];
    if (!codecs.some((c) => c.mimeType.toLowerCase() === wanted)) {
      return;
    }
    const ordered = [
      ...codecs.filter((c) => c.mimeType.toLowerCase() === wanted),
      ...codecs.filter((c) => c.mimeType.toLowerCase() !== wanted),
    ];
    const transceivers = this.renderstreaming?.getTransceivers()?.filter((t) => t.receiver.track.kind == "video");
    transceivers?.forEach((t: RTCRtpTransceiver) => {
      try {
        t.setCodecPreferences(ordered);
      } catch (error) {
        console.warn('[connessione] preferenza del codec non applicata', error);
      }
    });
  }

  showCodecSelect() {
    if (!this.supportsSetCodecPreferences) {
      // this.messageDiv.style.display = "block";
      // this.messageDiv.innerHTML = `Current Browser does not support <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpTransceiver/setCodecPreferences">RTCRtpTransceiver.setCodecPreferences</a>.`;

      this.showMessage = true;
      this.messageText = `Current Browser does not support <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpTransceiver/setCodecPreferences">RTCRtpTransceiver.setCodecPreferences</a>.`;

      return;
    }

    const codecs = RTCRtpSender.getCapabilities("video")?.codecs;
    let options: any[] = [];
    codecs?.forEach((codec) => {
      if (["video/red", "video/ulpfec", "video/rtx"].includes(codec.mimeType)) {
        return;
      }
      // const option = document.createElement("option");
      // option.value = (codec.mimeType + " " + (codec.sdpFmtpLine || "")).trim();
      // option.innerText = option.value;
      // this.codecPreferences.appendChild(option);

      options.push({
        value: (codec.mimeType + " " + (codec.sdpFmtpLine || "")).trim(),
        text: (codec.mimeType + " " + (codec.sdpFmtpLine || "")).trim()
      })

    });
    // this.codecPreferences.disabled = false;
    this.codecPreferencesDisabled = false;
  }



  showStatsMessage() {
    this.intervalId = setInterval(async () => {
      if (this.renderstreaming == null) {
        return;
      }

      const stats = await this.renderstreaming.getStats();
      if (stats == null) {
        return;
      }

      const array = createDisplayStringArray(stats, this.lastStats);
      if (array.length) {
        // this.messageDiv.style.display = "block";
        // this.messageDiv.innerHTML = array.join("<br>");
        // this.showMessage = environment.showStatsMessage && true;
        this.showMessage = this.environmentService.get('showStatsMessage') && true;
        this.messageText = array.join("<br>");
      }
      this.lastStats = stats;
    }, 1000);
  }

  clearStatsMessage() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.lastStats = undefined;
    this.intervalId = null;
    // this.messageDiv.style.display = "none";
    // this.messageDiv.innerHTML = "";
    this.showMessage = false;
    this.messageText = "";
  }

  toggleMic() {
      if(this.micon) {
        if (this.localStream) {
          this.localStream.getAudioTracks().forEach((track: MediaStreamTrack) => {
            track.enabled = false;
          });
        }
        this.micon = false;
        if(this.isLocalTranslating) {
          this.toggleLocalTranslation();
        }
      }
      else {
        if (this.localStream) {
          this.localStream.getAudioTracks().forEach((track: MediaStreamTrack) => {
            track.enabled = true;
          });
          this.micon = true;
          return;
        }
        this.startLocalVideo(null, true).then(async (localStream: MediaStream) => {

          /**
           * Setup local audio graph
           */
          this.audioTranslatorService.setTenantAndConnection(this.tenantId, this.connectionId);
          const managedStream = await this.audioTranslatorService.setupLocalAudioGraph(localStream);
          // this.localStream.getAudioTracks().forEach((track: MediaStreamTrack) => {
          //   this.localStream.removeTrack(track);
          // });
          // managedStream.getAudioTracks().forEach((track: MediaStreamTrack) => {
          //   this.localStream.addTrack(track);
          // })

          this.localStream.getVideoTracks().forEach((track: MediaStreamTrack) => {
            managedStream.addTrack(track);
          })

          this.localStream = managedStream;

          this._attachLocalStream(this.localStream);
          this.micon = true;
        }).catch((err) => {
          console.log(err);
        })
      }
  }

  _attachLocalStream(localStream: MediaStream) {


    localStream.getTracks().forEach((track: MediaStreamTrack) => {
      if(track.kind == "audio"){
        // On the line already negotiated with the drawing channel: no new offer to the headset.
        // Before that line exists (first seconds of the call) the channel setup attaches it.
        if(this.micTransceiver){
          this.micTransceiver.sender.replaceTrack(track).catch((error) => {
            console.warn('[connessione] microfono non collegato alla chiamata', error);
          });
          this.addedStreamTransceiver = [this.micTransceiver];
        }
      }
      // this.recorderService.addLocalTrack(track);
      this.videoService.addTrack(track, false);
    })
  }

  restartNegotiation() {
    const peer = this.renderstreaming?.getPeer();
    if(peer){
      const pc = peer.getPeerConnection();
      if(pc && pc.onnegotiationneeded){
        const e = new Event('negotiationneeded');
        pc.onnegotiationneeded(e);
      }
    }
  }

  startLocalVideo(videoSource: string | boolean | null, audioSource: string | boolean | false, videoWidth?: number, videoHeight?: number): Promise<MediaStream> {
    return new Promise((resolve, reject) => {
      try {
        let constraints: any = {
          video: false,
          audio: false
        }
        // {
        //   video: { deviceId: videoSource ? { exact: videoSource } : undefined },
        //   audio: { deviceId: audioSource ? { exact: audioSource } : undefined }
        // };

        if (videoSource != null) {
          if (typeof videoSource == 'string') {
            constraints.video = { deviceId: { exact: videoSource } }
          } else if (videoSource == true) {
            constraints.video = true;
          }
        }

        if (audioSource != null) {
          if (typeof audioSource == 'string') {
            constraints.audio = { deviceId: { exact: audioSource } }
          } else if (audioSource == true) {
            constraints.audio = true;
          }
        }

        if (videoWidth && videoWidth != 0) {
          constraints.video.width = videoWidth;
        }
        if (videoHeight && videoHeight != 0) {
          constraints.video.height = videoHeight;
        }

        // const localStream = await navigator.mediaDevices.getUserMedia(constraints)
        // this.localStream = localStream;
        // resolve(localStream);

        navigator.mediaDevices.getUserMedia(constraints).then((localStream: MediaStream) => {
          this.localStream = localStream;
          this.localStream.getTracks().forEach((track: MediaStreamTrack) => {
            this.videoService.addTrack(track, false);
          })
          resolve(localStream);
        })
      } catch (err) {
        Logger.error(`mediaDevice.getUserMedia() error:${err}`);
        reject(err);
      }
    })

  }

  onAddTrack(data: any){
    if(!this.remoteStream) {
      this.remoteStream = new MediaStream();
    }
    // this.recorderService.addRemoteTrack(data.stream ?? data.track);
    // this.videoService.addTrack(data.track, true);
    if(data.track.kind == "video"){
      // this.videoPlayer.addTrack(data.track);
      // qui aggiungo la traccia video remota
      this.videoService.addTrack(data.track, true);
      this.remoteStream.addTrack(data.track);
      return;
    }
    this.audioTranslatorService.addRemoteStream(data.stream ?? data.track).then((remoteManagedStream: MediaStream) => {
      remoteManagedStream.getTracks().forEach((track: MediaStreamTrack) => {
          // this.videoPlayer.addTrack(track);
          // qui aggiungo la traccia audio remota che passa attraverso l'audio context
          this.videoService.addTrack(track, true);
          this.remoteStream?.addTrack(track);
          // this.recorderService.addRemoteTrack(track);
      })
      if (this.resumeRemoteTranslation && !this.isRemoteTranslating) {
        this.resumeRemoteTranslation = false;
        this.toggleRemoteTranslation();
      }
    })

    // this.videoPlayer.addTrack(data.track);
  }

  toggleRecording() {
    if(this.isRecording){
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  startRecording() {
    if(!this.recorderService.isRecording()) {
      this.recorderService.start().catch((err) => {
        console.log(err);
        this.isRecording = false;
      }).then(() => {
        this.isRecording = true;
        this.startRecordingClock();
      })
    }
  }

  // Elapsed time shown on the record button ("REC 01:23")
  private startRecordingClock() {
    const startedAt = Date.now();
    this.recordingTime = '00:00';
    clearInterval(this.recordingTimer);
    this.recordingTimer = setInterval(() => {
      if (!this.isRecording) {
        clearInterval(this.recordingTimer);
        return;
      }
      const seconds = Math.floor((Date.now() - startedAt) / 1000);
      this.recordingTime = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    }, 1000);
  }

  stopRecording() {
    if(this.recorderService.isRecording()) {
      this.recorderService.stop().catch((err) => {
        console.log(err);
      }).then(() => {
        this.saveVideoRecordedOnServer();
        this.recorderService.download();

      }).finally(() => {
        this.isRecording = false;
      })
    }
  }

  saveVideoRecordedOnServer() {
    // const windowKey = environment.recordedVideoWindowKey ?? 'recordedBlob';
    const windowKey = this.environmentService.get('recordedVideoWindowKey') ?? 'recordedBlob';
    this.recorderService.setOnWindow(windowKey);
    this.djangoChannelService.sendData({
      event: 'saveVideo',
      data: {
        windowKey: windowKey
      }
    });
  }

  startBlur() {
    if(this.isBlur){
      return;
    }

    const recognitionOptions: FaceDetectionOptions | undefined = this.recognitionModel == 'tiny' ? {
            model: 'tiny',
            blurRadius: 12,
            detectionInterval: 300,
            faceTimeout: 1000,
            fps: 25,
            inputSize: 512,
            treshold: 0.3
        } : this.recognitionModel == 'ssd' ? { 
          model: 'ssd',
          blurRadius: 12,
          detectionInterval: 300,
          faceTimeout: 1000,
          fps: 25,
          inputSize: 512, 
          treshold:0.4
        } : this.recognitionModel == 'mtcnn' ? undefined : undefined

    this.isBlur = true;
    // const recognitionOptions = {
    //         model: 'tiny',
    //         blurRadius: 12,
    //         detectionInterval: 300,
    //         faceTimeout: 1000,
    //         fps: 25,
    //         inputSize: 224,
    //         treshold: 0.3
    //     }

        // const recognitionOptions = {
        //     model: 'tiny',
        //     blurRadius: 12,
        //     detectionInterval: 300,
        //     faceTimeout: 1000,
        //     fps: 25,
        //     inputSize: 512,
        //     treshold: 0.3
        // }
    this.videoService.addFilter(this.blurVideoFilterService, [], {options: this.recognitionOptions ?? recognitionOptions});
  }

  stopBlur() {
    this.videoService.removeFilter(this.blurVideoFilterService);
    this.isBlur = false;
  }

  toggleBlur() {
    if(this.isBlur){
      this.stopBlur();
    } else {
      this.startBlur();
    }
  }

  async loadBlurVideoFilterModel() {
    // await this.blurVideoFilterService.loadModels({ modelUrl: 'https://justadudewhohacks.github.io/face-api.js/models', model: 'tiny' });
    // await this.blurVideoFilterService.loadModels({ modelUrl: '/assets/models', model: 'tiny' });
    // this.recognitionModel = 'ssd';
    await this.blurVideoFilterService.loadModels({ modelUrl: this.recognitionModelUrl, model: this.recognitionModel });
  }
  async loadBlurVideoFilterLibrary() {
    await this.blurVideoFilterService.loadLibraries();
  }


  @HostListener('document:keydown', ['$event'])
  onDiagnosticsShortcut(event: KeyboardEvent) {
    if (event.ctrlKey && event.altKey && event.code === 'KeyD') {
      event.preventDefault();
      this.toggleDiagnostics();
    }
  }

  toggleDiagnostics() {
    this.showDiagnostics = !this.showDiagnostics;
    this.writeStorage(DIAGNOSTICS_STORAGE_KEY, this.showDiagnostics ? '1' : null);
    if (this.showDiagnostics) {
      this.diagnosticsTimer = setInterval(() => void this.refreshDiagnostics(), 1000);
    } else {
      this.stopDiagnostics();
    }
  }

  private stopDiagnostics() {
    if (this.diagnosticsTimer) {
      clearInterval(this.diagnosticsTimer);
      this.diagnosticsTimer = null;
    }
    this.diagnostics = null;
    this.lastDiagnosticsStats = undefined;
  }

  private async refreshDiagnostics() {
    const stats = await this.renderstreaming?.getStats();
    if (!stats) {
      this.diagnostics = null;
      return;
    }
    this.diagnostics = readCallDiagnostics(stats, this.lastDiagnosticsStats);
    this.lastDiagnosticsStats = stats;
  }

  private readStorage(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  private writeStorage(key: string, value: string | null) {
    try {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
    } catch {
      // Private mode: the panel simply stays closed at the next call
    }
  }

}
